import { Injectable, ElementRef } from '@angular/core';
   import { BehaviorSubject, filter, Subject, take } from 'rxjs';

   @Injectable({
     providedIn: 'root',
   })
   export class ElementRefService {
     private elementRefSourceHeader = new Subject<ElementRef>();
     elementRefHeader$ = this.elementRefSourceHeader.asObservable();

     private elementRefSourceFooter = new Subject<ElementRef>();
     elementRefFooter$ = this.elementRefSourceFooter.asObservable();

     setElementRefHeader(elementRef: ElementRef) {
       this.elementRefSourceHeader.next(elementRef);
     }
     setElementRefFooter(elementRef: ElementRef) {
      this.elementRefSourceFooter.next(elementRef);
    }

    getElementRefHeader(): ElementRef {
         var element:  ElementRef;
        this.elementRefSourceHeader.subscribe((elementRef: ElementRef) => {
          element = elementRef;
          console.log(' var element:  ElementRef;', element);
          return element;
        });
        
        return element;
    }

    getElementRefFooter(): ElementRef {
      var element:  ElementRef;
     this.elementRefSourceFooter.subscribe((elementRef: ElementRef) => {
       element = elementRef;
       return element;
     });
     return element;
 }

    private headerSubject = new BehaviorSubject<ElementRef | null>(null);
    header$ = this.headerSubject.asObservable();

    setHeader(element: ElementRef) {
      this.headerSubject.next(element);
    }

    getHeader(): ElementRef | null {
      return this.headerSubject.value;
    }

    private footerSubject = new BehaviorSubject<ElementRef | null>(null);
    footer$ = this.headerSubject.asObservable();

    setFooter(element: ElementRef) {
      this.footerSubject.next(element);
    }

    getFooter(): ElementRef | null {
      return this.footerSubject.value;
    }

   }